import type { LoaderProps } from 'rsuite'
import React from 'react'
import classNames from 'classnames'

import { Loader, Placeholder } from 'rsuite'

import './AppLoader.scss'

/*
  TODO: replace any with corresponding types
*/

function AppLoader (props: any) {
  const content = props.content || 'Загружаемся'

  return (
    <div className="AppLoader">
      <Loader
        content={content}
        size="lg"
        backdrop
        center
        speed="slow"
        {...props}
      />
    </div>
  )
}

AppLoader.Inner = function (props: any) {
  return (
    <div className="AppLoaderInner">
      <Loader {...props} center backdrop />
    </div>
  )
}

AppLoader.Inline = function ({ center, ...props }: any) {
  const classes = classNames('AppLoaderInline', {
    'AppLoaderInline--center': center
  })

  return (
    <div className={classes}>
      <Loader size="sm" {...props} />
    </div>
  )
}

AppLoader.Spinner = function (props: any) {
  return (
    <div className="AppLoaderSpinner">
      <Loader size="sm" />
    </div>
  )
}

AppLoader.Rows = function ({ rows = 10, columns = 4, rowHeight = 16 }) {
  return (
    <>
      <Placeholder.Grid
        rows={rows}
        columns={columns}
        rowHeight={rowHeight}
        active
      />
    </>
  )
}

AppLoader.RowsWithText = function ({
  rows = 10,
  columns = 6,
  rowHeight = 12,
  rowMargin = 12,
  ...props
}) {
  return (
    <div className="AppLoaderRowsWithText">
      <Placeholder.Grid
        rows={rows}
        columns={columns}
        rowHeight={rowHeight}
        rowMargin={rowMargin}
      />
      <Loader {...props} center vertical size="md" />
    </div>
  )
}

AppLoader.FieldProgress = (props: LoaderProps) => <Loader {...props} />

export default AppLoader
